function Rule() {
	this._field = ''
	this._operator = ''
	this._value = ''

	this.field = function (value) {
		if (value === undefined) {
			return this._field
		} else {
			this._field = value
			return this
		}
	}

	this.operator = function (value) {
		if (value === undefined) {
			return this._operator
		} else {
			this._operator = value
			return this
		}
	}

	this.value = function (value) {
		if (value === undefined) {
			return this._value
		} else {
			this._value = value
			return this
		}
	}

	this.toJSON = function () {
		return {
			field: this._field,
			operator: this._operator,
			value: this._value
		}
	}
}

function GroupRule() {
	this.condition = 'and'
	this.rules = []

	// this.toJSON = function () {
	//   var tempRules = []
	//   for (var i = 0, m = this.rules.length; i < m; i++) {
	//     tempRules.push(this.rules[i].toJSON())
	//   }
	//   return {
	//     condition: this.condition,
	//     rules: tempRules
	//   }
	// }
}

function QueryBuilder() {
	this.Database = ''
	this.Table = ''
	this.Method = 'get'
	this.Select = []
	this.Where = new GroupRule()
	this.Order = []
	this.Limit = 5000
	this.Offset = 0
	this.RecordsJSON = []

	this.addRule = function (rule) {
		this.Where.rules.push(rule)
	}

	this.addJSONRecords = function (record) {
		this.RecordsJSON.push(record)
	}

	// this.toJSON = function () {
	//   return {
	//     Database: this.Database,
	//     Table: this.Table,
	//     Method: this.Method,
	//     Select: this.Select,
	//     Where: this.Where.toJSON(),
	//     Order: this.Order,
	//     Limit: this.Limit,
	//     Offset: this.Offset,
	//     RecordsJSON: this.RecordsJSON
	//   }
	// }
}

export default {
	QueryBuilder,
	GroupRule,
	Rule,
	STR_OPERATOR: {
		EQUAL: '__exact',
		I_EQUAL: '__iexact',
		CONTAINS: '__contains',
		I_CONTAINS: '__icontains',
		IN: '__in',
		START_WITH: '__startswith',
		END_WITH: '__endswith',
		IS_NULL: '__isnull'
	},
	NUM_OPERATOR: {
		EQUAL: '__exact',
		IN: '__in',
		IS_NULL: '__isnull',
		RANGE: '__range',
		GREATER_THEN: '__gt',
		GREATER_THEN_EQUAL: '__gte',
		LESS_THEN: '__lt',
		LESS_THEN_EQUAL: '__lte'
	},
	A_STR_OPERATOR: {
		EQUAL: 's_exact',
		GREATER_THEN: 's_gt',
		GREATER_THEN_EQUAL: 's_gte',
		LESS_THEN: 's_lt',
		LESS_THEN_EQUAL: 's_lte',
		I_CONTAINS: 's_icontain' // owkTRY
	},
	A_NUM_OPERATOR: {
		EQUAL: 'n_exact',
		GREATER_THEN: 'n_gt',
		GREATER_THEN_EQUAL: 'n_gte',
		LESS_THEN: 'n_lt',
		LESS_THEN_EQUAL: 'n_lte'
	}
}
